import React from 'react';
import DefaultFieldsSettings from '../components/Settings/DefaultFields';

function DefaultFieldsRoute(props) {
  return <DefaultFieldsSettings {...props} />;
}

export default DefaultFieldsRoute;
